import { getSubjectColorIndex } from "@/lib/strapi/formatters";
import { buildFullPath } from "@/lib/utils/routing";
import { Resources } from "@/types/subject-schema";
import { useSearchParams } from "next/navigation";
import {
  useSubTopicMeta,
  useTopicMeta,
} from "../../../../../../components/CoreDataProvider";
import TabsComponent from "./TabsComponent";

export default function SubTopicThemeTabs({
  subjectNameLower,
  currentResource,
  topicDocumentId,
  currentSubTopicId,
}: {
  subjectNameLower: string;
  currentResource: Resources | "all";
  topicDocumentId: string;
  currentSubTopicId: string;
}) {
  const subjectColorIndex = getSubjectColorIndex(subjectNameLower);
  const activeSubTheme = useSearchParams().get("activeTheme");
  const topicMeta = useTopicMeta(topicDocumentId);
  const subTopicMeta = useSubTopicMeta(currentSubTopicId);
  const subThemeTabs = Object.entries(subTopicMeta.subThemes ?? {}).reduce(
    (
      acc: { label: string; value: string }[],
      [subThemeDocumentId, subThemeMeta]
    ) => {
      acc.push({
        label: subThemeMeta.title,
        value: `${buildFullPath({
          subject: subjectNameLower,
          resource: currentResource,
          topicNumber: topicMeta.index.toString(),
          topicTitle: topicMeta.title,
          subTopicTitle: subTopicMeta.title,
        })}?activeTheme=${subThemeDocumentId}`,
      });
      return acc;
    },
    []
  );
  subThemeTabs.unshift({
    label: `All sub-themes`,
    value: `${buildFullPath({
      subject: subjectNameLower,
      resource: currentResource,
      topicNumber: topicMeta.index.toString(),
      topicTitle: topicMeta.title,
      subTopicTitle: subTopicMeta.title,
    })}?activeTheme=all`,
  });

  return (
    <TabsComponent
      subjectColorIndex={subjectColorIndex}
      activeTabValue={`${buildFullPath({
        subject: subjectNameLower,
        resource: currentResource,
        topicNumber: topicMeta.index.toString(),
        topicTitle: topicMeta.title,
        subTopicTitle: subTopicMeta.title,
      })}?activeTheme=${activeSubTheme}`}
      type={"theme"}
      tabs={subThemeTabs}
    />
  );
}
